module.exports = __webpack_public_path__ + "img/3-2.75da66c4.svg";